<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
 <vs-sidebar 
 click-not-close
   position-right
    parent="body" 
  default-index="1"
  color="primary"
  class="add-new-data-sidebar items-no-padding cstm-add-data-sidebar"
  :hidden-background="true"
  spacer
  v-model="isSidebarActiveLocal">

      <!-- <div class="header-sidebar" slot="header"> -->
        <div class="flex items-center justify-between px-6">
          <h4 class="heading-holder">Add Task</h4>
          <feather-icon icon="PlusIcon" @click="openAddForm" class="cursor-pointer"></feather-icon>

          <feather-icon icon="XIcon" class="cursor-pointer" @click.stop="isSidebarActiveLocal = false" />
          <!-- addSideBar = false -->
        </div>
        <vs-divider class="mb-0"></vs-divider>
     <form data-vv-scope="Add_Task" v-if="addform">
      <div class="form-holder p-6 pt-2">        
        <vs-row>
          <vs-col vs-lg="8" vs-sm="12">
            <div class="vx-row w-full">
              <div class="vx-col w-full mb-4">
                <vs-input v-validate="'required'" class="w-full" label="Title" data-vv-name="title" v-model="title"/>
                <div v-if="errors.has('Add_Task.title')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Task.title') }}</div>
              </div>
              <div class="vx-col w-full mb-4">
                <label class="text-xs">Description</label>
                <vs-textarea v-validate="'required'" data-vv-name="description" placeholder="Start typing the details about the task...." v-model="description" />
                <div v-if="errors.has('Add_Task.description')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Task.description') }}</div>
              </div>
          
              <div class="vx-col sm:w-1/2 w-full">
                              <!-- <label class="text-xs">Date</label> -->

               <flat-pickr 
                        v-validate="'required'"
                        style="width:100%"
                        v-model="date"
                        placeholder="Choose Date"
                        label="Date"
                        data-vv-name="taskdate" 
                                      
                         />
                       <div 
                        v-if="errors.has('Add_Task.taskdate')" 
                        style="color:red;" class="invalid-feedback">
                       {{ errors.first(`Add_Task.taskdate`) }}
                       </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                 <flat-pickr :config="configdateTimePicker"
                  v-model="time" placeholder="Choose time"
                  data-vv-name="tasktime" 

                  />

                <div v-if="errors.has('Add_Task.tasktime')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Task.tasktime') }}</div>
              </div>
             

              <div class="vx-col w-full my-4">
                 <vs-input 
                 v-validate="'required'"
                data-vv-name="outcomes"
                class="w-full"
                label="Outcomes"

                v-model="outcome"/>
                                <div v-if="errors.has('Add_Task.outcomes')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Task.outcomes') }}</div>

              </div>
               <div class="vx-col w-full mb-4">
                       <vs-checkbox color="success" v-model="is_complete">Mark As Complete</vs-checkbox>

              </div>
            </div>
          </vs-col>
          <vs-col vs-lg="4" vs-sm="12">
            <div class="mb-4">
                <label class="text-sm">Related to</label>
<!-- {{task_list}} -->
                 <v-select multiple 
                      :closeOnSelect="false"
                      v-model="related_to_id"
                      :reduce="option => option.users_id"
                      label="first_name"
                      :options="task_list"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                      <!-- {{related_to_id}} -->
<!-- {{task_list}} -->
                <!-- <v-select v-validate="'required'" v-model="related_to_id"  :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
            </div>
            <div class="mb-4">
                      <label class="text-sm">Attendees</label>

                 <v-select
                    autocomplete
                    multiple 
                    :reduce="option => option.users_id"
                    label="first_name"
                    :closeOnSelect="false"
                    v-model="colloaborator_id"
                    :options="task_list"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                    
                <!-- <v-select v-validate="'required'" v-model="colloaborator_id"  :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="footer-sidebar" slot="footer">
        <!-- Save & Cancel Button -->
        <div class="flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2"
           @click="closeAddForm" 
           type="border" color="danger">Cancel</vs-button>
          <vs-button class="ml-4 mt-2" @click.prevent="submitData">Save</vs-button>
        </div>
      </div>
     </form>


     <!-- Edit Form -->
<form data-vv-scope="Edit_Task" v-if="editform">
      <div class="form-holder p-6 pt-2">        
        <vs-row>
          <vs-col vs-lg="8" vs-sm="12">
            <div class="vx-row w-full">
              <div class="vx-col w-full mb-4">
                <vs-input v-validate="'required'" class="w-full" label="Title" data-vv-name="title" v-model="editedTask.title"/>
                <div v-if="errors.has('Edit_Task.title')"  style="color:red;" class="invalid-feedback">{{ errors.first('Edit_Task.title') }}</div>
              </div>
              <div class="vx-col w-full mb-4">
                <label class="text-xs">Description</label>
                <vs-textarea v-validate="'required'" data-vv-name="description" placeholder="Start typing the details about the task...." v-model="editedTask.description" />
                <div v-if="errors.has('Edit_Task.description')"  style="color:red;" class="invalid-feedback">{{ errors.first('Edit_Task.description') }}</div>
              </div>
          
              <div class="vx-col sm:w-1/2 w-full">
                              <!-- <label class="text-xs">Date</label> -->

               <flat-pickr 
                        v-validate="'required'"
                        style="width:100%"
                        v-model="editedTask.date"
                        placeholder="Choose Date"
                        label="Date"
                        data-vv-name="taskdate" 
                                      
                         />
                       <div 
                        v-if="errors.has('Edit_Task.taskdate')" 
                        style="color:red;" class="invalid-feedback">
                       {{ errors.first(`Edit_Task.taskdate`) }}
                       </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                 <flat-pickr :config="configdateTimePicker"
                  v-model="editedTask.time" placeholder="Choose time"
                  data-vv-name="tasktime" 

                  />

                <div v-if="errors.has('Edit_Task.tasktime')"  style="color:red;" class="invalid-feedback">{{ errors.first('Edit_Task.tasktime') }}</div>
              </div>
             

              <div class="vx-col w-full mb-4">
                 <vs-input 
                 v-validate="'required'"
                data-vv-name="outcomes"
                class="w-full"
                label="Outcomes"

                v-model="editedTask.outcome"/>
                    <div v-if="errors.has('Edit_Task.outcomes')"  style="color:red;" class="invalid-feedback">{{ errors.first('Edit_Task.outcomes') }}</div>

              </div>
               <div class="vx-col w-full mb-4">
                       <vs-checkbox color="success" v-model="editedTask.is_complete">Mark As Complete</vs-checkbox>

              </div>
            </div>
          </vs-col>
          <vs-col vs-lg="4" vs-sm="12">
            <div class="vx-row w-full">
              <div class="vx-col w-full mb-4">
                <label class="text-sm">Related to</label>

                 <v-select multiple 
                      :closeOnSelect="false"
                      v-model="editedTask.related_to_id"
                      label="first_name"
                      :options="task_list"
                      :reduce="option => option.users_id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'" />

                      
<!-- {{task_list}} -->
                <!-- <v-select v-validate="'required'" v-model="related_to_id"  :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
              </div>
              <div class="vx-col w-full mb-4">
                      <label class="text-sm">Attendees(1)</label>

                 <v-select
                    autocomplete
                    multiple 
                    :reduce="option => option.users_id"
                    label="first_name"
                    :closeOnSelect="false"
                    v-model="editedTask.collaborator_id"
                    :options="task_list"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <!-- <v-select v-validate="'required'" v-model="colloaborator_id"  :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
              </div>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="footer-sidebar" slot="footer">
        <!-- Save & Cancel Button -->
        <div class="flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2"
           @click="closeEditForm" 
           type="border" color="danger">Cancel</vs-button>
          <vs-button class="ml-4 mt-2" @click.prevent="updateActivityTask">Save</vs-button>
        </div>
      </div>
     </form>

     <!-- Edit Form -->

     <!-- Data Fetching -->
      <component 
    :is="scrollbarTag"
    class="scroll-area--data-list-add-new"
    :settings="settings"
    :key="$vs.rtl">
      <div class="p-6">

        <!-- Product Image -->  
              <!-- {{sidebarTaskMeta}}
              {{notesdata}} -->


      <!-- {{leadId}} -->

      <!-- <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button> -->
      <!-- {{taskListData}} -->
      <vs-row>
        <vs-card v-for="taskData in taskListData" :key="taskData.activities_task_id">
            <vs-row>
                  
                  
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
              
            </vs-col>
            <vs-col vs-type="flex"  vs-justify="left" vs-align="center" vs-w="9">
              <h4>{{taskData.title}}</h4>
          </vs-col>
            <vs-col  vs-type="flex" vs-justify="right" vs-align ="center" vs-w="1">
                 <vs-button radius color="primary" 
                    icon="edit"
                    class="mr-1"    
                    @click="openEditForm(taskData.activities_task_id)"
                  ></vs-button> 
            </vs-col>
            <vs-col vs-type="flex" vs-justify="right"  vs-align="center" vs-w="1"> 
                    <vs-button radius
                    color="danger"
                    icon="delete"
                    @click="DeleteTask(taskData.activities_task_id)"
                     >
                    </vs-button> 
                  </vs-col>
            </vs-row>

            <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1"></vs-col>
            <vs-col vs-type="flex"  vs-justify="left" vs-align="center" vs-w="9">{{taskData.description}}</vs-col>
            <vs-col  vs-type="flex" vs-justify="right" vs-align ="center" vs-w="2"> </vs-col>
           </vs-row>
  <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1"></vs-col>
            <vs-col vs-type="flex"  vs-justify="left" vs-align="center" vs-w="4">Related:
                <span v-for="(related_user,index) in taskData.related_to_id" :key="index">{{related_user.first_name}}</span>
            </vs-col>
             <vs-col vs-type="flex"  vs-justify="left" vs-align="center" vs-w="3">Collabaraor:
                               <span v-for="(collaborator_user,index) in taskData.collaborator_id" :key="index">{{collaborator_user.first_name}},</span>

             </vs-col>
            <vs-col  vs-type="flex" vs-justify="right" vs-align ="center" vs-w="4"> Outcomes</vs-col>
           </vs-row>

           <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1"></vs-col>
            <vs-col vs-type="flex"  vs-justify="left" vs-align="center" vs-w="6">{{taskData.due_datetime}}</vs-col>
             <vs-col vs-type="flex"  vs-justify="left" vs-align="center" vs-w="3">Completed:<b :style="taskData.is_complete ? 'color:red':'color:green'">{{taskData.is_complete ? 'Yes' : "No"}}</b>


             </vs-col>
            <vs-col  vs-type="flex" vs-justify="right" vs-align ="center" vs-w="2"> </vs-col>
           </vs-row>
           <small style="float:right">{{taskData.created_at}}</small>
        </vs-card>
        <infinite-loading @infinite="infiniteHandler" spinner="circles"></infinite-loading>

     
    </vs-row>

                   
      </div>
         
    </component>
     <!-- Data Fetching -->

    </vs-sidebar>
</template>

<script>
import {InsertNewTask, FetchCustomerList, FetchLeadTask, UpdateLeadTask, DeleteActivityTask} from '@/api/activitynotes'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    platformType:{
      type:String,
      required:true
    },
    leadId:{
      required : true
    }
    // notesdata:{
    //   type: Array,
    //   default: () => []
    // }
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    flatPickr
  },
  data () {
    return {


      addform:false,
      editform:false,

      task_list:[],
      configdateTimePicker: {
        //         time_24hr: true,

        // enableTime: true,
        // noCalendar: true,
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        dateFormat: 'H:i:ss',
        time_24hr: true
     
      },
      //task todo//
      title:'',
      description:'',
      related_to_id:[],
      colloaborator_id:[],
      date:'',
      time:'', 
      type:'',  //platform type
      is_complete:'',
      outcome:'',

      //editedform
      editedTask :{
        title:'',
        description:'',
        related_to_id:[],
        collaborator_id:[],
        date:'',
        time:'', 
        type:'',  //platform type
        is_complete:'',
        outcome:'',
        activities_todo_id:''
      },

      //editedform

      //tasktodo
      page:1,

      taskListData:[],
      sidebarTaskMeta:{
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      //taskpage

    
      //boolean
      //leadid
      dataId: null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  mounted () {
    this.fetch_customer_list()
    this.fetchActivityTask()
    
  },

  // watch: {
  //   isSidebarActive (val) {
  //     if (!val) return
  //     if (Object.entries(this.data).length === 0) {
  //       this.initValues()
  //       this.$validator.reset()
  //     } else {
      
  //       this.initValues()
  //     }
  //   }
  // },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeTaskSidebar', false)
         
        }
      }
    },
   
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.notescontent = ''
    },
    openAddForm () {

      this.editform = false
      this.addform = true

    },
    closeAddForm () {
      this.addform = false
    },
    closeEditForm () {
      this.editform = false
    },
    openEditForm (id) {
      this.addform = false
      this.editform = true
      const data = this.taskListData.find(element => element.activities_task_id === id)
      const res = data.due_datetime.split(' ')

      
      this.editedTask.title = data.title
      this.editedTask.description = data.description

      this.editedTask.outcome = 'outcomes'
      
      this.editedTask.related_to_id = data.related_to_id.map(item => {
        return item.user_id
      })
      
      this.editedTask.collaborator_id = data.collaborator_id.map(item => {
        return item.user_id
      })
      this.editedTask.date = res[0]
      this.editedTask.time = res[1]
      // // editedTask.type=  data.//platform type
      this.editedTask.is_complete = data.is_complete
      this.editedTask.activities_todo_id = data.activities_task_id
      //   this.editedTask.outcome =  data.   
      
      //       created_at: "22/09/2020"
      // : "sfdfsdfsdf"
      // due_datetime: "2020-09-23 14:26:00"
      // is_complete: 1
      // item_id: 1
      // title: "Totelfsgsd
      
      
      
      // this.fetchSingleForm(id)
    },
    submitData () {
      this.$validator.validateAll('Add_Task').then(result => {
        if (result) {
          const customerId = this.$store.getters.customerId
          const payload = {
            title : this.title,
            description : this.description,
            related_to_id : this.related_to_id,
            collaborator_id :this.colloaborator_id,
            date : this.date,
            time : this.time,
            type : this.platformType,
            item_id : this.leadId,
            outcome : this.outcome,
            is_complete : this.is_complete ? 1 : 0,
            customer_id:customerId
          }
          
          this.addInsertTask(payload)
          // this.initValues()
        }
      })
    },
    //fetch_customer_list
    async fetch_customer_list () {
      const {data} = await FetchCustomerList(this.$store.getters.customerId)
      this.task_list = data.data.list
      
    },
    //fetch_customer_list
    async addInsertTask (payload) {
      try {
        const {data} = await InsertNewTask(payload)
        
        // const newTask = {
        //   activities_todo_id: data.data.activities_todo_id,
        //   created_at: data.data.created_at,
        //   customer_id: data.data.customer_id,
        //   description: data.data.description,
        //   due_datetime: data.data.due_datetime,
        //   id: data.data.id,
        //   is_complete: data.data.is_complete,
        //   item_id: data.data.item_id,
        //   module_id: data.data.module_id,
        //   outcome: data.data.outcome,
        //   title: data.data.title,
        //   user_id: data.data.user_id


        // }
        const newData = data.data.activites_todos_details
        
        
        // const newData = {
        //   note_content :data.data.activities_note.note_content,
        //   title : data.data.activities_note.title,
        //   activities_note_id :data.data.activities_note.activities_note_id
        // }
     
        // 
        
        this.$emit('closeTaskSidebar', 'New Task Added Successfully')
      } catch (e) {
        
      }
    },
    initdefault () {
      this.title = ''
      this.description = ''
      this.related_to_id = []
      this.colloaborator_id = []
      this.date = ''
      this.time = ''
      this.type = ''  //platform type
      this.is_complete = ''
      this.outcome = ''
    },
    async fetchActivityTask () {

      const customerId = this.$store.getters.customerId

      
      const {data} = await FetchLeadTask(this.page, this.leadId, customerId) 
      
      this.taskListData = data.data.list
      this.sidebarTaskMeta = data.data.meta

      
      // if  (data.data.results) {
      //   const dataActivityNotes = data.data.results
      //   this.notesdata.push(...dataActivityNotes)
      // }
     
      // this.sidebarTaskMeta = data.data.meta
      // 
    },
    updateActivityTask () {
      this.$validator.validateAll('Edit_Task').then(result => {
        if (result) {
          const payload = this.editedTask
          
          // payload.collaborator_id = this.editedTask.collaborator_id.map(({ user_id }) => user_id)

          // payload.collaborator_id = this.editedTask.collaborator_id.map(ele => ele.user_id)
          

          this.updateData(this.editedTask)
        }
      })

    },
    async updateData (payload) {

      try {
        await  UpdateLeadTask(payload)
        this.$emit('closeTaskSidebar', 'Task Updated Successfully')

        // 
      } catch (error) {
        
      }

      this.editform = false
      // 
    },
    infiniteHandler ($state) {
     
      if (this.sidebarTaskMeta.has_next) {

        FetchLeadTask(this.page + 1, this.leadId).then(({data}) =>  {
         
          this.taskListData.push(...data.data.list)
          this.sidebarTaskMeta = data.data.meta
          
          
          this.page++
          //increment of page

          if (!this.sidebarTaskMeta.has_next) {
            $state.complete()

          } else {
            $state.loaded()
          }
        })
      } else {
        $state.complete()
        
      }

      // this.fetchactivitynotesdata(this.sidebarTaskMeta, this.leadId)
  
    },
    DeleteTask (id) {
      this.deleteTask(id)
    },
    async deleteTask (id) {
      this.editform = false
      this.addform = false
      const data = await DeleteActivityTask(id)
      const dlt_id  = this.taskListData.findIndex(item => item.activities_task_id === id)
      this.taskListData.splice(dlt_id, 1)
      
      
    }
  }
}
</script>

<style lang="scss" scoped>

.flatpickr-input[readonly] {
    cursor: pointer;
    width: 100%;
}
// [dir] .flatpickr-input[readonly] {
//     width: 100%;
// }

.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 550px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: scroll;
    }
}
//  [dir] .vs-content-sidebar.items-no-padding .vs-sidebar--items{
//     overflow-y: scroll;
//   }
body {
  margin: 0;
}
</style>

<style>
  .add-new-data-sidebar .vs-sidebar-position-right {
    width: 480px !important;
    max-width: 480px !important;
  }
  .heading-holder {
    width: 80%;;
  }
  @media (max-width: 575px) {
    .add-new-data-sidebar .vs-sidebar-position-right {
      width: 80% !important;
      max-width: 480px !important;
    }
  }
</style>